import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { OPERATIONAL_EVENT_TYPE, SCREEN_EVENT_TYPE, TRACK_EVENT_TYPE, UI_EVENT_TYPE } from '../../constants';
import { fireAnalytics } from '../../utils/fire-analytics';
var getFixedActionAndActionSubject = function getFixedActionAndActionSubject(props) {
  var eventName = props.eventName,
    action = props.action,
    actionSubject = props.actionSubject;
  if (eventName && (action || actionSubject)) {
    throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
  }
  var eventNameSplit = eventName ? eventName.split(' ') : [];
  var fixedAction = action || eventNameSplit[1];
  var fixedActionSubject = actionSubject || eventNameSplit[0];
  if (!fixedAction || !fixedActionSubject) {
    throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
  }
  return {
    action: fixedAction,
    actionSubject: fixedActionSubject
  };
};
var getFixedActionSubjectId = function getFixedActionSubjectId(props) {
  var componentName = props.componentName,
    actionSubjectId = props.actionSubjectId;
  if (componentName && actionSubjectId) {
    throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
  }
  var fixedActionSubjectId = actionSubjectId || componentName;
  return {
    actionSubjectId: fixedActionSubjectId
  };
};
var FireComponent = /*#__PURE__*/function (_Component) {
  function FireComponent() {
    _classCallCheck(this, FireComponent);
    return _callSuper(this, FireComponent, arguments);
  }
  _inherits(FireComponent, _Component);
  return _createClass(FireComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        type = _this$props.type,
        attributes = _this$props.attributes;
      if (!this.props.createAnalyticsEvent) {
        throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
      }
      var _getFixedActionAndAct = getFixedActionAndActionSubject(this.props),
        action = _getFixedActionAndAct.action,
        actionSubject = _getFixedActionAndAct.actionSubject;
      var _getFixedActionSubjec = getFixedActionSubjectId(this.props),
        actionSubjectId = _getFixedActionSubjec.actionSubjectId;
      var analyticsEvent = this.props.createAnalyticsEvent({
        action: action
      });
      fireAnalytics(analyticsEvent, type, {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
      });
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(Component);
var WithAnalytics = withAnalyticsEvents()(FireComponent);
export var FireUIAnalytics = function FireUIAnalytics(props) {
  return /*#__PURE__*/React.createElement(WithAnalytics, _extends({}, props, {
    type: UI_EVENT_TYPE
  }));
};
export var FireTrackAnalytics = function FireTrackAnalytics(props) {
  return /*#__PURE__*/React.createElement(WithAnalytics, _extends({}, props, {
    type: TRACK_EVENT_TYPE
  }));
};
export var FireOperationalAnalytics = function FireOperationalAnalytics(props) {
  return /*#__PURE__*/React.createElement(WithAnalytics, _extends({}, props, {
    type: OPERATIONAL_EVENT_TYPE
  }));
};
export var FireScreenAnalytics = function FireScreenAnalytics(props) {
  return /*#__PURE__*/React.createElement(WithAnalytics, _extends({}, props, {
    type: SCREEN_EVENT_TYPE,
    eventName: "screen viewed"
  }));
};